import React from "react";
import { Tab } from "react-admin";
import { useLocation } from "react-router-dom";

import { DeviationsList } from "../../deviations/List/List";

const DeviationsTab = ({ resource, basePath, ...props }) => {
	const { pathname } = useLocation();

	if (!props.record) return <Tab {...props}>Loading</Tab>;
	return (
		<Tab {...props} basePath={pathname} resource="deviations">
			<DeviationsList filterDefaultValues={{ order_id: props.record.id }} isOrderDeviationTab={true} />
		</Tab>
	);
};

export default DeviationsTab;
